/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomFieldDefinitionFunnelsAddBodyParams } from '../models/CustomFieldDefinitionFunnelsAddBodyParams';
import type { CustomFieldDefinitionFunnelsGetResponse } from '../models/CustomFieldDefinitionFunnelsGetResponse';
import type { CustomFieldDefinitionFunnelsUpdateBodyParams } from '../models/CustomFieldDefinitionFunnelsUpdateBodyParams';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CrmCustomFieldsDefinitionsFunnelsService {
    /**
     * Get funnel mappings for a custom field definition
     * @param definitionId
     * @returns CustomFieldDefinitionFunnelsGetResponse Ok
     * @throws ApiError
     */
    public static getCustomFieldDefinitionFunnels(
        definitionId: number,
    ): CancelablePromise<CustomFieldDefinitionFunnelsGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/crm/custom-fields/definitions/{definitionId}/funnels',
            path: {
                'definitionId': definitionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Replace all funnel mappings for a custom field definition
     * @param definitionId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateCustomFieldDefinitionFunnels(
        definitionId: number,
        requestBody: CustomFieldDefinitionFunnelsUpdateBodyParams,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/crm/custom-fields/definitions/{definitionId}/funnels',
            path: {
                'definitionId': definitionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Add funnel mappings to a custom field definition
     * @param definitionId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static addCustomFieldDefinitionFunnels(
        definitionId: number,
        requestBody: CustomFieldDefinitionFunnelsAddBodyParams,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/crm/custom-fields/definitions/{definitionId}/funnels',
            path: {
                'definitionId': definitionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Remove a single funnel mapping from a custom field definition
     * @param definitionId
     * @param funnelId
     * @returns void
     * @throws ApiError
     */
    public static removeCustomFieldDefinitionFunnel(
        definitionId: number,
        funnelId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/crm/custom-fields/definitions/{definitionId}/funnels/{funnelId}',
            path: {
                'definitionId': definitionId,
                'funnelId': funnelId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
}
